import { GetterTree } from 'vuex'
import { RootState } from '@/store/state'
import { ScriptPageState } from './state'
import {
  PassStep,
  ScriptCardContent,
  ScriptCardResponse,
} from '@/models/scripts'
import { CardVariant } from '@/constants/scripts'

export const getters: GetterTree<ScriptPageState, RootState> = {
  getScriptPageId(state): string | undefined {
    return state.scriptId
  },

  getScriptPageCardId(state): string | undefined {
    return state.cardId
  },

  getScriptPageCard(state): ScriptCardResponse | undefined {
    return !state.cardId ? undefined : state.cards[state.cardId]
  },

  getScriptPageCardNumber(state): number | undefined {
    return state.cardNum
  },

  getScriptPageCardVariant(state): CardVariant {
    return state.variant
  },

  getScriptPageCardContent(state, getters): ScriptCardContent | undefined {
    const card = getters.getScriptPageCard

    return card?.content[getters.getScriptPageCardVariant]
  },

  getScriptPageHistory(state): PassStep[] | undefined {
    return state.history
  },
}
